import styled from 'styled-components'
import FontAwesome from 'react-fontawesome'

export const DeviceDetailsImage = styled.img`
    width: 100%;
    height: 275px;
    object-fit: ${props => (props.contain ? 'contain' : 'cover')};
    display: inline-block;
    background-color: var(--ios-bg-color);
`

export const DeviceDetailsName = styled.h1`
    padding: 30px 10px 0 10px;
    margin: 0;
    text-align: center;
    font-size: 1.8rem;
`

export const DeviceDetailsLastUpdateHeading = styled.div`
    padding: 20px 10px 0;
    text-align: center;
    font-size: 1.2rem;
    
    &:first-letter {
        text-transform: uppercase;
    }
`

export const DeviceDetailsLastUpdate = styled.h2`
    padding: 10px 10px 0;
    text-align: center;
    font-size: 1.2rem;
    color: var(--secondary);
    
    &:first-letter {
        text-transform: uppercase;
    }
`

export const DeviceDetailsIrrigationDuration = styled.div`
    padding: 0 10px;
    text-align: center;
    font-size: 1.2rem;
    color: var(--secondary);
`

export const DeviceDetailsOverview = styled.div`
    text-align: center;
    margin-bottom: 20px;
`

export const DeviceDetailsOverviewIcon = styled.img`
    width: 100%;
    height: 60px;
    object-fit: contain;
`

export const DeviceDetailsOverviewText = styled.div`
    font-size: 1.2rem;
    padding-top: 5px;
    font-weight: 300;
    
`

export const AddPlantIcon = styled(FontAwesome)`
    color: var(--cyan);
    position: absolute;
    right: 10px;
    top: 8px;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Devices/DeviceDetails.js